import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "./text";
import Button from "./button";
import { getImageUrl } from "../libs/utils/image";
import translate from "../libs/locale";
import variables from "../assets/variables";
import { ImageMapper } from "../assets/images";
import { Image } from "src/common/components/image";
import { SCREEN_WIDTH } from "../libs/utils/constants";
import { OrderStatus } from "../types/response/master";
import { OrderItem } from "../types/response/orders";
import { capitalizeFirstLetter } from "../libs/utils/dataUtils";
import { getStatusFromId } from "../libs/utils/orderStatusMap";

type Props = {
  item: OrderItem;
  openDetail: (id: string) => void;
  remove: (id: string) => void;
};

const OrderNotificationItem = ({
  item,
  openDetail,
  remove,
}: Props) => {
  const storeImage = getImageUrl(item.store.images[0]);
  const totalItems = item.items.reduce((acc, cur) => {
    return acc + cur.count;
  }, 0);

  return (
    <View style={styles.main}>
      <View style={[styles.root, styles.container]}>
        <Image source={{ uri: storeImage }} style={styles.image} />
        <View style={styles.nameContainer}>
          <Text style={styles.storeName} numberOfLines={1}>
            {item.store_name}
          </Text>
          <Text style={styles.storeName} numberOfLines={1}>
            {getStatusFromId(item.status)}
          </Text>
          <Text style={styles.items} numberOfLines={1}>
            {translate("nItems", { totalItems })}
          </Text>
        </View>
        <View style={styles.buttons}>
          <Button
            text={translate("view")}
            style={styles.buttonContainer}
            textStyle={styles.buttonText}
            onPress={() => openDetail(item._id)}
          />
          <Button
            style={styles.removeContainer}
            onPress={() => remove(item._id)}
          >
            <Image source={ImageMapper.Close} style={styles.removeIcon} />
          </Button>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 1,
    marginBottom: 3,
    borderWidth: 0.25,
    borderColor:"#ececec",
    overflow:'hidden'
  },
  main: {
    paddingHorizontal: 10,
    width: SCREEN_WIDTH - 30,
    alignSelf: "flex-end",
  },
  container: {
    backgroundColor: "#fff",
    borderRadius: 2,
    padding: 10,
    flexDirection: "row",
    alignItems: "center",
    height: 67,
  },
  storeName: {
    color: "#364650",
    fontFamily: " MontserratBold",
    fontSize: 14,
    flex: 1,
    lineHeight: 14,
  },
  image: {
    height: 40,
    width: 40,
    borderRadius: 20,
  },
  items: {
    color: "#364650",
    fontSize: 12,
    flex: 1,
  },
  nameContainer: {
    flex: 1,
    marginRight: 20,
    marginLeft: 10,
  },
  buttons: {
    flexDirection: "row",
    alignItems: "center",
  },
  buttonContainer: {
    height: 40,
    borderRadius: 10,
  },
  buttonText: {
    fontSize: 12,
    lineHeight: 12,
  },
  removeContainer: {
    marginLeft: 10,
    height: 17,
    width: 17,
    borderRadius: 17,
    backgroundColor: variables.$disabledText,
    alignItems: "center",
    justifyContent: "center",
  },
  removeIcon: {
    height: 10,
    width: 10,
    tintColor: "#acacac",
  },
});

export default OrderNotificationItem;
